import axiosClient from "../../../api/axiosClient";

export async function getAiAgentSettings() {
  const response = await axiosClient.get("/ai-agent/settings");
  return response?.data ?? {};
}

export async function updateAiAgentSettings(payload) {
  const response = await axiosClient.put("/ai-agent/settings", payload);
  return response?.data ?? {};
}

export async function getResponseCompositionPolicy() {
  const response = await axiosClient.get("/ai-agent/response-composition-policy");
  return response?.data ?? {};
}

export async function updateResponseCompositionPolicy(payload) {
  const response = await axiosClient.put(
    "/ai-agent/response-composition-policy",
    payload
  );
  return response?.data ?? {};
}

export async function getAiAgentUsage(params = {}) {
  const response = await axiosClient.get("/ai-agent/usage", { params });
  const payload = response?.data ?? {};
  return {
    ...payload,
    items: Array.isArray(payload.items) ? payload.items : [],
    total: Number(payload.total) || 0,
    page: Number(payload.page) || 1,
    pageSize: Number(payload.pageSize) || 20,
  };
}

export async function getControlledAnswerSendLogs(params = {}) {
  const response = await axiosClient.get("/ai-agent/usage/controlled-answer-sends", {
    params,
  });
  const payload = response?.data ?? {};
  return {
    items: Array.isArray(payload.items) ? payload.items : [],
    total: Number(payload.total) || 0,
    page: Number(payload.page) || 1,
    pageSize: Number(payload.pageSize) || 20,
  };
}

export async function getAiKnowledgeSources(params = {}) {
  const response = await axiosClient.get("/ai-agent/knowledge", { params });
  const payload = response?.data ?? {};
  return {
    items: Array.isArray(payload.items) ? payload.items : [],
    total: Number(payload.total) || 0,
    page: Number(payload.page) || 1,
    pageSize: Number(payload.pageSize) || 20,
  };
}

export async function getAiKnowledgeSource(id) {
  const response = await axiosClient.get(`/ai-agent/knowledge/${id}`);
  return response?.data ?? {};
}

export async function createAiKnowledgeSource(payload) {
  const response = await axiosClient.post("/ai-agent/knowledge", payload);
  return response?.data ?? {};
}

export async function updateAiKnowledgeSource(id, payload) {
  const response = await axiosClient.put(`/ai-agent/knowledge/${id}`, payload);
  return response?.data ?? {};
}

export async function publishAiKnowledgeSource(id) {
  const response = await axiosClient.post(`/ai-agent/knowledge/${id}/publish`);
  return response?.data ?? {};
}

export async function disableAiKnowledgeSource(id) {
  const response = await axiosClient.post(`/ai-agent/knowledge/${id}/disable`);
  return response?.data ?? {};
}

export async function deleteAiKnowledgeSource(id) {
  const response = await axiosClient.delete(`/ai-agent/knowledge/${id}`);
  return response?.data ?? {};
}

export async function getAiMediaAssetSenders() {
  const response = await axiosClient.get("/chat-inbox/senders");
  const payload = response?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  return [];
}

export async function getCrmContactsAll() {
  const response = await axiosClient.get("/contacts/all");
  const payload = response?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

export async function getAiMediaAssets(params = {}) {
  const response = await axiosClient.get("/ai-agent/media-assets", { params });
  const payload = response?.data ?? {};
  return {
    items: Array.isArray(payload.items) ? payload.items : [],
    total: Number(payload.total) || 0,
    page: Number(payload.page) || 1,
    pageSize: Number(payload.pageSize) || 20,
  };
}

export async function getAiMediaAsset(id) {
  const response = await axiosClient.get(`/ai-agent/media-assets/${id}`);
  return response?.data ?? {};
}

export async function createAiMediaAsset(payload) {
  const response = await axiosClient.post("/ai-agent/media-assets", payload);
  return response?.data ?? {};
}

export async function updateAiMediaAsset(id, payload) {
  const response = await axiosClient.put(`/ai-agent/media-assets/${id}`, payload);
  return response?.data ?? {};
}

export async function deleteAiMediaAsset(id) {
  const response = await axiosClient.delete(`/ai-agent/media-assets/${id}`);
  return response?.data ?? {};
}

export async function uploadAiMediaAsset(formData) {
  const response = await axiosClient.post("/ai-agent/media-assets/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response?.data ?? {};
}

export async function getAiLeadQualificationConfig() {
  const response = await axiosClient.get("/ai-agent/lead-qualification/config");
  return response?.data ?? {};
}

export async function initializeAiLeadQualificationFlow(existingFlowId = null) {
  const response = await axiosClient.post("/ai-agent/lead-qualification/flows/default", { existingFlowId });
  return response.data;
}

export async function getLeadQualificationReminders(flowDefinitionId) {
  const response = await axiosClient.get(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/reminders`
  );
  return response?.data ?? {};
}

export async function updateLeadQualificationReminderPolicy(flowDefinitionId, payload) {
  const response = await axiosClient.put(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/reminders/policy`,
    payload
  );
  return response?.data ?? {};
}

export async function createLeadQualificationReminderStep(flowDefinitionId, payload) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/reminders/steps`,
    payload
  );
  return response?.data ?? {};
}

export async function updateLeadQualificationReminderStep(flowDefinitionId, stepId, payload) {
  const response = await axiosClient.put(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/reminders/steps/${stepId}`,
    payload
  );
  return response?.data ?? {};
}

export async function createLeadQualificationConfirmationCheckpoint(flowDefinitionId, payload) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/confirmation-checkpoints`,
    payload
  );
  return response?.data ?? {};
}

export async function updateLeadQualificationConfirmationCheckpoint(
  flowDefinitionId,
  checkpointId,
  payload
) {
  const response = await axiosClient.put(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/confirmation-checkpoints/${checkpointId}`,
    payload
  );
  return response?.data ?? {};
}

export async function createLeadQualificationConfirmationCheckpointV2(
  flowDefinitionId,
  payload
) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/confirmation-checkpoints/v2`,
    payload
  );
  return response?.data ?? {};
}

export async function updateLeadQualificationConfirmationCheckpointV2(
  flowDefinitionId,
  checkpointId,
  payload
) {
  const response = await axiosClient.put(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/confirmation-checkpoints/${checkpointId}/v2`,
    payload
  );
  return response?.data ?? {};
}

export async function convertLeadQualificationConfirmationCheckpointToV2(
  flowDefinitionId,
  checkpointId,
  payload
) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/confirmation-checkpoints/${checkpointId}/convert-to-v2`,
    payload
  );
  return response?.data ?? {};
}

export async function previewLeadQualificationConfirmationCheckpointV2(
  flowDefinitionId,
  payload
) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/confirmation-checkpoints/v2/preview`,
    payload
  );
  return response?.data ?? {};
}

export async function activateLeadQualificationConfirmationCheckpoint(
  flowDefinitionId,
  checkpointId
) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/confirmation-checkpoints/${checkpointId}/activate`
  );
  return response?.data ?? {};
}

export async function deactivateLeadQualificationConfirmationCheckpoint(
  flowDefinitionId,
  checkpointId
) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/confirmation-checkpoints/${checkpointId}/deactivate`
  );
  return response?.data ?? {};
}

export async function activateLeadQualificationReminderStep(flowDefinitionId, stepId) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/reminders/steps/${stepId}/activate`
  );
  return response?.data ?? {};
}

export async function deactivateLeadQualificationReminderStep(flowDefinitionId, stepId) {
  const response = await axiosClient.post(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/reminders/steps/${stepId}/deactivate`
  );
  return response?.data ?? {};
}

export async function createAiBusinessProofLocation(payload) {
  const response = await axiosClient.post(
    "/ai-agent/lead-qualification/proof-locations",
    payload
  );
  return response?.data ?? {};
}

export async function updateAiBusinessProofLocation(id, payload) {
  const response = await axiosClient.put(
    `/ai-agent/lead-qualification/proof-locations/${id}`,
    payload
  );
  return response?.data ?? {};
}

export async function deactivateAiBusinessProofLocation(id) {
  const response = await axiosClient.delete(
    `/ai-agent/lead-qualification/proof-locations/${id}`
  );
  return response?.data ?? {};
}

export async function createAiLeadFlowField(payload) {
  const response = await axiosClient.post(
    "/ai-agent/lead-qualification/fields",
    payload
  );
  return response?.data ?? {};
}

export async function updateAiLeadFlowField(id, payload) {
  const response = await axiosClient.put(
    `/ai-agent/lead-qualification/fields/${id}`,
    payload
  );
  return response?.data ?? {};
}

export async function createAiLeadMediaTriggerRule(payload) {
  const response = await axiosClient.post(
    "/ai-agent/lead-qualification/media-trigger-rules",
    payload
  );
  return response?.data ?? {};
}

export async function updateAiLeadMediaTriggerRule(id, payload) {
  const response = await axiosClient.put(
    `/ai-agent/lead-qualification/media-trigger-rules/${id}`,
    payload
  );
  return response?.data ?? {};
}

export async function getAiLeadQualificationDebug(params = {}) {
  const response = await axiosClient.get("/ai-agent/lead-qualification/debug", {
    params,
  });
  return response?.data ?? {};
}

export async function getLeadQualificationReminderJobs(flowDefinitionId, params = {}) {
  const response = await axiosClient.get(
    `/ai-agent/lead-qualification/flows/${flowDefinitionId}/reminders/jobs`,
    { params }
  );
  const payload = response?.data ?? {};
  return {
    items: Array.isArray(payload.items) ? payload.items : [],
    total: Number(payload.total) || 0,
    page: Number(payload.page) || 1,
    pageSize: Number(payload.pageSize) || 20,
  };
}

export async function getDelayedResponsePolicies(params = {}) {
  const response = await axiosClient.get("/ai-agent/delayed-response-policies", {
    params,
  });
  const payload = response?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  return [];
}

export async function createDelayedResponsePolicy(payload) {
  const response = await axiosClient.post(
    "/ai-agent/delayed-response-policies",
    payload
  );
  return response?.data ?? {};
}

export async function updateDelayedResponsePolicy(id, payload) {
  const response = await axiosClient.put(
    `/ai-agent/delayed-response-policies/${id}`,
    payload
  );
  return response?.data ?? {};
}

export async function activateDelayedResponsePolicy(id) {
  const response = await axiosClient.post(
    `/ai-agent/delayed-response-policies/${id}/activate`
  );
  return response?.data ?? {};
}

export async function deactivateDelayedResponsePolicy(id) {
  const response = await axiosClient.post(
    `/ai-agent/delayed-response-policies/${id}/deactivate`
  );
  return response?.data ?? {};
}

export async function previewDelayedResponsePolicy(payload) {
  const response = await axiosClient.post(
    "/ai-agent/delayed-response-policies/preview",
    payload
  );
  return response?.data ?? {};
}

export async function getDelayedResponseJobs(params = {}) {
  const response = await axiosClient.get("/ai-agent/delayed-response-jobs", {
    params,
  });
  const payload = response?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  return [];
}

export async function resetAiLeadQualificationSession(payload) {
  const response = await axiosClient.post(
    "/ai-agent/lead-qualification/debug/reset-session",
    payload
  );
  return response?.data ?? {};
}

export async function runAiTestConsole(payload) {
  const response = await axiosClient.post("/ai-agent/test", payload);
  return response?.data ?? {};
}

export async function getControlledAnswerCards() {
  const response = await axiosClient.get("/ai-agent/controlled-answer-cards");
  return Array.isArray(response?.data) ? response.data : [];
}

export async function createControlledAnswerCard(payload) {
  const response = await axiosClient.post(
    "/ai-agent/controlled-answer-cards",
    payload
  );
  return response?.data ?? {};
}

export async function updateControlledAnswerCard(id, payload) {
  const response = await axiosClient.put(
    `/ai-agent/controlled-answer-cards/${id}`,
    payload
  );
  return response?.data ?? {};
}

export async function activateControlledAnswerCard(id) {
  const response = await axiosClient.post(
    `/ai-agent/controlled-answer-cards/${id}/activate`
  );
  return response?.data ?? {};
}

export async function deactivateControlledAnswerCard(id) {
  const response = await axiosClient.post(
    `/ai-agent/controlled-answer-cards/${id}/deactivate`
  );
  return response?.data ?? {};
}

export async function runAiQualificationPreview(payload) {
  const response = await axiosClient.post("/ai-agent/test/qualification-preview", payload);
  return response?.data ?? {};
}

export async function getAiAgentQuotas() {
  const response = await axiosClient.get("/ai-agent/usage/quotas");
  return response?.data ?? {};
}
export async function getAiAgentActivity(params) {
  const response = await axiosClient.get("/ai-agent/usage/activity", { params });
  return response?.data ?? {};
}
